import config from "util/config";
import { setProfile } from "features/ProfileSlice";
import { setCurrentPoint } from "features/CurrentPointSlice";
import { monthNames } from "utility/date";
import { GetCustomerData, GetMe } from "./Module/Customer";

export function isNewApiEnabled() {
  const newApiUrl = config.config().NEW_API_URL;
  return Boolean(newApiUrl && String(newApiUrl).trim());
}

export function mapPointViewToCurrentPoint(pointView) {
  if (!pointView) return null;

  const wordBook365 = pointView.wordBook365 || {};

  return {
    customer: pointView.customer,
    currentPoint: pointView.currentPoint,
    currentHeart: pointView.currentHeart,
    isSchedualGame: pointView.isSchedualGame,
    isSchedualSticker: pointView.isSchedualSticker,
    usedHeart: pointView.usedHeart,
    haveLucky: wordBook365.haveLucky,
    redeemLucky: wordBook365.redeemLucky,
    redeemHeart: wordBook365.redeemHeart,
    isLoaded: true,
  };
}

export async function fetchCustomerProfile({ id }) {
  const _return = {
    status: false,
    result: null,
    source: "legacy",
    pointView: null,
  };

  if (isNewApiEnabled()) {
    try {
      const res = await GetMe();
      const data = res?.data ?? res?.response?.data;

      if (data?.resultCode === "20000") {
        _return.status = true;
        _return.result = data.resultData;
        _return.source = "me";
        _return.pointView = data.resultData?.pointView ?? null;
        return _return;
      }

      console.log("GetMe non-success, fallback to legacy >>", data);
    } catch (e) {
      console.log("GetMe failed, fallback to legacy >>", e);
    }
  }

  try {
    const res = await GetCustomerData({ id });
    const data = res?.data;

    if (data?.resultCode === "20000") {
      _return.status = true;
      _return.result = data.resultData;
      _return.source = "legacy";
    }
  } catch (e) {
    console.log("ERR fetchCustomerProfile:", e);
  }

  return _return;
}

export function prepareBirthDate(birthDate) {
  if (!birthDate) return "";

  const date = birthDate.split("-");
  const monthName = monthNames.find((item) => item.id == date[1]);
  date[1] = monthName?.name ?? date[1];
  date[0] = Number(date[0]) + 543;
  return date.reverse().join(" ");
}

export async function loadCustomerProfileToStore({ dispatch, customerId }) {
  const profileRes = await fetchCustomerProfile({ id: customerId });

  if (!profileRes.status || !profileRes.result) {
    return { ...profileRes, applied: false };
  }

  if (profileRes.source === "me" && profileRes.pointView) {
    const currentPointData = mapPointViewToCurrentPoint(profileRes.pointView);
    if (currentPointData) {
      dispatch(setCurrentPoint(currentPointData));
    }
  }

  dispatch(
    setProfile({
      ...profileRes.result,
      customerId: profileRes.result.id,
      birthDateConvert: prepareBirthDate(profileRes.result.birthDate),
    })
  );

  return { ...profileRes, applied: true };
}
